export default (props, vars) => props?.['required'] && 'required';
